import { useBacklogSelector } from '../index.tsx';
import { isCheckboxSelectionMode } from '../selectors/app/index.tsx';
import { getSelectedCards } from '../selectors/cards/index.tsx';

export const useShowCheckbox = () => {
	const isCheckboxSelection = useBacklogSelector(isCheckboxSelectionMode);
	const hasMoreThanOneSelectedCard = useBacklogSelector(getSelectedCards).length > 1;
	return isCheckboxSelection || hasMoreThanOneSelectedCard;
};
